import * as Environment from "../base/Environment.js";

import {AnimatableSprite} from "../base/Display2D.js";

//
// SiteSection extends AnimatableSprite
//

export const SiteSection = function (context) {
	AnimatableSprite.apply (this, arguments);
	
};

SiteSection.prototype = Object.create (AnimatableSprite.prototype);

SiteSection.prototype.takeElement = function (element) {
	this.element.parentNode.removeChild (this.element);
	this.element = element;
	
};

SiteSection.prototype.startLoading = function () {
	this.didStartLoading = true;
	
};

SiteSection.prototype.setViewSize = function (viewSize) {
	this.viewSize = viewSize;
	
};

SiteSection.prototype.scroll = function (onAwake) {
	
};

SiteSection.prototype.awake = function () {
	this.isAwake = true;
	
};

SiteSection.prototype.sleep = function () {
	this.isAwake = false;
	
};

//
// ExternalSection extends SiteSection
//

export const ExternalSection = function (context) {
	SiteSection.apply (this, arguments);
	
};

ExternalSection.prototype = Object.create (SiteSection.prototype);

ExternalSection.prototype.takeElement = async function (element) {
	const externalClassName = element.getAttribute ("data-external-class-name");
	const module = await import ("./" + externalClassName + ".js");
	
	const externalSection = this.externalSection = this.attachSprite (module [externalClassName]);
	externalSection.takeElement (element);
	
	if (this.isAwake)
		externalSection.awake ();
	
};

ExternalSection.prototype.setViewSize = function (viewSize) {
	SiteSection.prototype.setViewSize.apply (this, arguments);
	
	this.externalSection?.setViewSize (viewSize);
	
};

ExternalSection.prototype.scroll = function (onAwake) {
	this.externalSection?.scroll (onAwake);
	
};

ExternalSection.prototype.awake = function () {
	this.externalSection?.awake ();
	
};

ExternalSection.prototype.sleep = function () {
	this.externalSection?.sleep ();
	
};

